if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      this.stickySubmitBtn = document.querySelector('.anchor_links_nav_section .sticky-submit-button');
      if(this.stickySubmitBtn) {
        const _this = this;
        this.stickySubmitBtn.addEventListener('click', function(e) {
          e.preventDefault();
          
          const targetHref = this.getAttribute('data-target-id');
          if(targetHref.length) {
            const targetEl = document.querySelector(targetHref);
            if(targetEl) {

            this.setAttribute('disabled', true);
            this.setAttribute('aria-disabled', true);
            this.classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

           targetEl.dispatchEvent(new Event('click', { bubbles: true }));
            }
          }
        
        });
      }

      this.initKlarnaPrice();
    }

    initKlarnaPrice() {
      const submitBtn = this.querySelector('.product-form__submit');
      const priceEl = this.querySelector('.klarna_price');

      if (!submitBtn || !priceEl) return;

      const waitForElement = (selector, timeout = 3000) => {
        return new Promise((resolve) => {
          const el = document.querySelector(selector);
          if (el) return resolve(el);

          const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
              observer.disconnect();
              resolve(el);
            }
          });

          observer.observe(document.body, { childList: true, subtree: true });

          setTimeout(() => {
            observer.disconnect();
            resolve(null);
          }, timeout);
        });
      };

      waitForElement('shopify-payment-terms').then((el) => {
        if (!el) {
          submitBtn.classList.add('without_klarna_info');
          return;
        }

        this.updateKlarnaPrice();

      });
    }
    updateKlarnaPrice(variantId = null) {
      const el = this.form.querySelector('shopify-payment-terms');
       if (!el) return;
      const meta = el.getAttribute('shopify-meta');
      if (!meta) return;

      const data = JSON.parse(meta);

      if (!variantId) {
      variantId = el.getAttribute('variant-id');
      }

      const variant = data.variants.find(v => v.id == variantId && v.available);

      if (!variant) return;

      const priceEl = this.querySelector('.klarna_price');
      priceEl.innerHTML = variant.price_per_term;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (this.submitButton.getAttribute('disabled') === 'true') return;

      this.isGridForm = this.form.classList.contains('card-product-form');

      if(this.isGridForm) {
        if(this.form.classList.contains('already_added')) {
          window.location = window.routes.cart_url;
          return false;
        }
      }
      
      this.handleErrorMessage();

      this.submitButton.setAttribute('disabled', true);
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
     
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          
          
           if(this.isGridForm) {
             this.form.classList.add('already_added');
             this.submitButton.querySelector('span').innerHTML = window.variantStrings.viewCart;
           }
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.setAttribute('disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.log(e);
          console.error(e);
        })
        .finally(() => {

            const custom_product_submit_popupEl = document.querySelector('.custom_product_submit_popup');
            if(custom_product_submit_popupEl) {
              custom_product_submit_popupEl.classList.remove('hide');
              document.body.classList.add('popup-open');
            }
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (!this.error) this.submitButton.removeAttribute('disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.submitButton.blur();

          
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
